module.exports = __webpack_public_path__ + "media/error1.2a5221f0.mp3";